import ConnectedDashboardItem from './ConnectedDashboardItem';

export default ConnectedDashboardItem;
